import { https, httpsFile } from './http.js';

export function index(id,company,page,currentpage){
    return httpsFile().get(`/pr-draft-details?company=${company}&id=${id}&page=${page}&currentpage=${currentpage}`);
}

export function store(data){
    return httpsFile().post(`/pr-draft-details`,data);
}

export function update(id,data){
    return httpsFile().post(`/pr-draft-details/${id}`,data);
}

export function destroy(id){
    return httpsFile().delete(`/pr-draft-details/${id}`);
}
